import * as Sentry from '@sentry/react'

import { endPointsToIgnore, isDebugSentry } from './consts'

export const handleBeforeBreadcrumb = (
  breadcrumb: Sentry.Breadcrumb,
  hint?: Sentry.BreadcrumbHint,
) => {
  if (['xhr', 'fetch'].includes(breadcrumb.category ?? '')) {
    const url = breadcrumb.data?.url || ''

    if (endPointsToIgnore.some((endpoint) => url.includes(endpoint))) {
      if (isDebugSentry) {
        console.log('Prevented sentry breadcrumb', breadcrumb)
      }

      return null
    }
  }

  if (
    breadcrumb.category === 'console' &&
    Array.isArray(breadcrumb.data?.arguments)
  ) {
    breadcrumb = {
      ...breadcrumb,
      data: {
        ...breadcrumb.data,
        arguments: breadcrumb.data?.arguments?.map((argument: unknown) =>
          typeof argument === 'object' ? JSON.stringify(argument) : argument,
        ),
      },
    }
  }

  // Enrich SVG/icon click breadcrumbs
  if (breadcrumb.category === 'ui.click' && hint?.event?.target) {
    const target = hint.event.target as SVGElement
    let svgElement: SVGElement | null = null

    // Check if the click was on an SVG element or its children (like <path>)
    if (target.tagName === 'svg' || target.tagName === 'SVG') {
      // Click was directly on SVG
      svgElement = target
    } else if (target.tagName === 'path' || target.tagName === 'PATH') {
      // Click was on a path inside SVG, get the parent SVG
      svgElement = target.closest('svg')
    } else if (target.closest('svg')) {
      // Click was on some other SVG child element
      svgElement = target.closest('svg')
    }

    if (svgElement) {
      const iconName = svgElement.dataset.iconName

      breadcrumb = {
        ...breadcrumb,
        data: {
          ...breadcrumb.data,
          iconName,
        },
      }
    }
  }

  if (isDebugSentry) {
    console.log('Sentry breadcrumb', breadcrumb)

    return null
  }

  return breadcrumb
}
